import { makeStyles } from 'tss-react/mui';

import { linearProgressClasses } from '@mui/material';

export default makeStyles({ name: 'GenerationProgress' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 34
    },
    progress: {
        height: 4,
        borderRadius: 2,
        backgroundColor: 'rgba(103, 106, 112, 0.15)',
        [`.${linearProgressClasses.bar}`]: {
            borderRadius: 4,
            background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%)'
        }
    },
    steps: {
        display: 'flex',
        gap: 24,
        overflowX: 'auto',
        scrollbarWidth: 'none',
        ['&::-webkit-scrollbar']: {
            display: 'none'
        }
    },
    step: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        whiteSpace: 'nowrap'
    },
    _completed: {
        color: '#232323'
    },
    _active: {
        color: '#232323',
        fontWeight: 600
    }
});
